<template>
       <div class=" mx-auto">
              <div class=" flex ">
                     <div class="h-screen w-1/2 bg-no-repeat bg-cover  bg-[url('./../../static/img/log.png')]">

                     </div>

                     <div class=" w-full h-screen flex flex-col justify-center items-center space-y-[39px] ">
                            <nuxt-img class="w-[100px] h-[100px] rounded-full"
                                   :src="`${$config.public.apiBaseUrl}app-config/logo`" />

                            <div class="space-y-[18px] flex justify-center">

                                   <div class=" text-center text-3xl font-semibold ">
                                          {{ t('loginHeaderText') }} {{ $config.public.laboratoryName }}
                                   </div>


                            </div>
                                   <!-- Language Selector -->
                                   <div class="flex items-center md:order-2">
                                          <Button text type="button" class="min-w-48 flex items-center gap-2"
                                                 @click="toggle">
                                                 <span>{{ i18n.locale.value === 'fr' ? '🇫🇷' : '🇺🇸' }}</span>
                                                 <span>{{ currentLang.name }}</span>
                                          </Button>

                                          <Popover ref="op">
                                                 <div class="flex flex-col gap-4">
                                                        <div>
                                                               <span class="font-medium block mb-2">Select
                                                                      Language</span>
                                                               <ul class="list-none p-0 m-0 flex flex-col">
                                                                      <li v-for="(lang, key) in language" :key="key"
                                                                             class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
                                                                             @click="changeLang(key)">
                                                                             <div>
                                                                                    <span class="font-medium">{{ lang
                                                                                           }}</span>
                                                                             </div>
                                                                      </li>
                                                               </ul>
                                                        </div>
                                                 </div>
                                          </Popover>
                                   </div>
                                   <MoleculeLoginForm />
                     </div>
              </div>

       </div>
</template>
<script setup lang="ts">
const { t } = useI18n();
definePageMeta({ title: 'Connection', layout: false });
useSeoMeta({
       title: 'Login'
})

// Language selector logic
const op = ref();
const toggle = (event: any) => {
       op.value.toggle(event);
}
const { setLocale } = useI18n()
const i18n = useI18n();
const language = reactive({ fr: 'Francais', en: 'English (US)' });
const currentLang = reactive({ name: i18n.locale.value == 'fr' ? language.fr : language.en });
const changeLang = (key: 'fr' | 'en') => {
       setLocale(key);
       currentLang.name = language[key];
       op.value.hide();
};
</script>
<style scoped></style>
